/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsJoin = createReactComponent("arrows-join", "IconArrowsJoin", [
  ["path", { d: "M3 7h5l3.5 5h9.5", key: "svg-0" }],
  ["path", { d: "M3 17h5l3.495 -5", key: "svg-1" }],
  ["path", { d: "M18 15l3 -3l-3 -3", key: "svg-2" }]
]);

export { IconArrowsJoin as default };
//# sourceMappingURL=IconArrowsJoin.js.map
